module.exports = __webpack_public_path__ + "img/undraw_tutorial_video_vtd1.f9d156a4.svg";